module.exports = __webpack_public_path__ + "img/profit.0637bbe6.svg";